export default {
    en: {
        monitorDevice: 'Device',
        preview: 'Preview',
        search: 'search',
        select: 'No Layer',
        view: 'View',
        captureImage: 'Snap Picture',
        warnMessage: 'Please remove a device before add a new one or drag it to replace',
        fullScreen: 'Full Screen',
        exitfullScreen: 'Exit Full Screen',
        placeholderTip: 'You can select one camera for now',
        dragOrclick: 'click on the video you want to play from the left or drag it here',
        start: 'Start',
        end: 'End',
        more: 'More',
        flod: 'Fold',
        viewAllResults: 'View all results',
        quitPlaying: 'Quit Playing',
        noLayer: 'No Layer',
        matchedBody: 'Matched Body',
        unmatchedBody: 'Unmatched Body',
        matchedLicensePlate: 'Matched License Plate',
        unmatchedLicensePlate: 'Unmatched License Plate',
        matchedVehicleAttribute: 'Matched Vehicle Attribute',
        unmatchedVehicleAttribute: 'Unmatched Vehicle Attribute',
        unidentifiedObjectRetention: 'Unidentified Object Retention',
        alarmDetails: 'alarmDetails',
        capture: 'Capture subject information',
        timeOfDuration: 'Time of Duration',
        socialDistance: 'Social Distance',
        validTime: 'Valid Time',
        SnapTime: 'Snap Time',
        portraitLibary: 'Portrait Libary',
        matchingRate: 'Matching Rate',
        visitors: 'Visitors',
        area: 'Area',
        device: 'Device',
        task: 'Task',
        status: 'Status',
        note: 'Note',
        equipment: 'Capture equipment',
        region: 'Region',
        processing: 'Alarm status processing',
        verify: 'verify',
        alarm: 'False alarm',
        remarks: 'Warning remarks',
        image: 'image({msg})',
        lastedTime: 'Lasted for {num}',
        lastedNumber: 'Number of people: {num}',
        ignore: 'Ignore',
        solved: 'Solve',
        confirmDelete: 'Are you sure to delete this alert?',
        confirmIgnore: 'Are you sure to mark this alert as ignored? ',
        confirmSolved: 'Are you sure to mark this alert as solved? ',
        critical: 'Critical',
        major: 'Major',
        minor: 'Minor',
        textarea: 'Typing',
        incidentCrowd: 'Crowd Counting',
        incidentQueueTiming: 'Queue Timing',
        incidentQueueCounting: 'Queue Counting',
        incidentOffDuty: 'Unauthorized Leave',
        crowdRetention: 'Crowd Retention',
        crowdCounting: 'Crowd Counting',
        crowdCounterflow: 'Crowd Counterflow',
        crowdIntrusion: 'Crowd Intrusion',
        closeSocialDistance: 'Close Social Distance',
        crowdGatherAndDispersion: 'Crowd Gather',
        crowdScatter: 'Crowd Dispersion',
        faceComparison: 'Face Comparison',
        faceBodyRecognition: 'Face & Body Recognition',
        unmatchedFaceComparison: 'Unmatched Face Comparison',
        statusContinue: 'In Progress',
        statusSolved: 'Solved',
        statusIgnored: 'Ignored',
        operator: 'Operator',
        tips: 'Tips',
        permanent: 'Always',
        tiggerMode: 'Tigger Mode',
        alertMode: 'Alert Mode',
        textDistance: 'Distance',
        gatherTime: 'Gather Time',
        portraitLibaryPhoto: 'Library Portrait',
        meters: 'Meters',
        gather: 'Gather',
        spread: 'Spread',
        concentric: 'Concentric',
        sameDirection: 'Same Direction',
        details: 'Details',
        snapRecord: 'Snap Record',
        allFilter: 'All Filter',
        basicFilter: 'Basic Filter',
        similarity: 'Similarity',
        noData: 'No Data',
        startPlaceholder: 'Start',
        endPlaceholder: 'End',
        pictures: 'pictures',
        week: 'Last one week',
        halfMonth: 'Last two weeks',
        layer: 'Layer',
        snapImage: 'Capture Portrait',
        analysis: 'Data Analysis Results',
        taskNote: 'Task Note',
    },
    zh: {
        monitorDevice: '设备',
        select: '请选择',
        view: '预览',
        search: '搜索',
        captureImage: '抓拍图像',
        warnMessage: '请先移出一个设备再添加新设备或拖拽设备去替代',
        fullScreen: '全屏',
        exitfullScreen: '退出全屏',
        placeholderTip: '您现在可以选择一个摄像头',
        dragOrclick: '从左侧单击要播放的视频，或将其拖动到此处',
        start: '开始时间',
        end: '结束时间',
        more: '更多',
        flod: '折叠',
        viewAllResults: '查看更多',
        quitPlaying: '退出播放',
        noLayer: '无图层',
        alarmDetails: '告警详情',
        capture: '抓拍主体信息',
        equipment: '抓拍设备',
        region: '所属区域',
        processing: '告警状态处理',
        verify: '核实',
        alarm: '误报',
        remarks: '告警备注1',
        image: '图片({msg})',
        timeOfDuration: '持续时间',
        socialDistance: '社交距离',
        SnapTime: '抓拍时间',
        validTime: '生效时间',
        portraitLibary: '人像库',
        matchingRate: '匹配度阈值',
        visitors: '实际滞留人数',
        area: '所属区域',
        device: '设备',
        task: '任务名称',
        status: '告警状态',
        note: '备注',
        lastedTime: '时长：{num}',
        lastedNumber: '人数：{num} 人',
        ignore: '忽略',
        solved: '解决',
        confirmDelete: '确认删除该警告？',
        confirmIgnore: '确认忽略该警告？',
        confirmSolved: '确认解决该警告？',
        critical: '重度',
        major: '中度',
        minor: '轻度',
        textarea: '备注',
        incidentCrowd: '人群统计',
        incidentQueueTiming: '排队时长',
        incidentQueueCounting: '排队人数',
        incidentOffDuty: '离岗检测',
        crowdRetention: '人群滞留',
        crowdCounting: '人群计数',
        crowdCounterflow: '人群逆流',
        crowdIntrusion: '人群入侵',
        closeSocialDistance: '社交距离过近',
        crowdGatherAndDispersion: '人群聚集',
        crowdScatter: '人群分散',
        faceComparison: '人脸比对',
        faceBodyRecognition: '人脸&人体识别',
        unmatchedFaceComparison: '人脸未比中',
        statusContinue: '进行中',
        statusSolved: '已解决',
        statusIgnored: '已忽略',
        operator: '操作员',
        tips: '提示',
        permanent: '永久生效',
        tiggerMode: '告警模式',
        alertMode: '告警触发方式',
        textDistance: '聚集人数',
        gatherTime: '聚集时间',
        portraitLibaryPhoto: '人像',
        meters: '人',
        gather: '聚集',
        spread: '分散',
        concentric: '同心',
        sameDirection: '同向',
        details: '详情',
        snapRecord: '抓拍记录',
        allFilter: '所有选项',
        basicFilter: '基础选项',
        similarity: '相似度',
        noData: '暂无数据',
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        pictures: '图片',
        week: '近一周',
        halfMonth: '近半月',
        layer: '算法图层',
        snapImage: '抓拍图',
        analysis: '数据挖掘结果',
        taskNote: '任务备注',
        matchedBody: '人体比中',
        unmatchedBody: '人体未比中',
        matchedLicensePlate: '车牌号比中',
        unmatchedLicensePlate: '车牌号未比中',
        matchedVehicleAttribute: '车辆属性比中',
        unmatchedVehicleAttribute: '车辆属性未比中',
        unidentifiedObjectRetention: '不明物品滞留',
    },
};
